import React, { useRef } from 'react';
import CommonToast from '@app/components/CommonToast';
import DialogPop from '@app/components/DialogPopup/dialogPop';
import { LoadingScreen } from '@app/components/Loading';
import { AppTopbarRef } from '@type/layout';
import { useMountEffect } from 'primereact/hooks';
import { Outlet } from 'react-router-dom';
import { AppFooter, AppTopbar } from './components';

const DefaultLayoutNoSideBar: React.FC = () => {
  const topbarRef = useRef<AppTopbarRef>(null);
  useMountEffect(() => {
    document.body.style.fontSize = '14px';
  });

  return (
    <div>
      <DialogPop />
      <LoadingScreen />
      <CommonToast />
      <AppTopbar ref={topbarRef} />
      <div className="layout-main-container layout-main-container-no-sidebar">
        <div className="layout-main">
          <Outlet />
        </div>
        <AppFooter />
      </div>
      {/* <AppConfig /> */}
      <div className="layout-mask" />
    </div>
  );
};

export default DefaultLayoutNoSideBar;
